import styled from 'styled-components'
import Markdown from 'react-markdown'

import Link from './Link/styled'

const StyledMarkdown = styled(Markdown).attrs({
  components: { a: Link },
})`
  ${Link} {
    display: inline-block;
    padding: 0;

    color: inherit;
    border-radius: 0;
    box-shadow: ${props => props.theme.colors.primary} 0px -2px 0px inset;
    text-decoration: none;
    border-width: 0px 0px 2px;
    border-style: solid;
    border-color: ${props => props.theme.colors.primary};
    transition: background 0.15s cubic-bezier(0.33, 0.66, 0.66, 1) 0s;
  }

  ${Link}:hover {
    text-decoration: none;
    background: ${props => props.theme.colors.primary};
    color: ${props => props.theme.fontColorWithBackground.primary};
  }
`

export default StyledMarkdown
